import styled from 'styled-components';

const BpIcon = styled('span')(() => ({
  borderRadius: '50%',
  width: 20,
  height: 20,
  boxShadow:
    'inset 0 0 0 2px rgba(151,151,151), inset 0 -2px 0 rgba(151,151,151,1)',
  backgroundColor: '#fff',
  backgroundImage:
    'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(45, 102, 186)',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: '#ebf1f5',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background: 'rgba(206,217,224,.5)',
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: 'rgba(45, 102, 186)',
  boxShadow: 'none',
  backgroundImage:
    'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
    display: 'block',
    width: 10,
    height: 6,
    border: '1.5px solid #fff',
    transform: 'rotate(-45deg) translate(0px,8px)',
    borderRight: 'none',
    borderTop: 'none',
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: 'rgba(45, 102, 186)',
  },
});
export { BpIcon, BpCheckedIcon };
